package com.kinoshazam.uiKit.components.videoItem

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.painter.Painter

data class VideoState(
    val id: Int,
    val title: String,
    val image: String? = null,
    val placeHolder: Painter,
    val placeHolderColor: Color? = null,
    val onAction: (Int) -> Unit = {},
)
